import {
	CACHE_ADDRESS,
	UPSERT_ADDRESS_REQUEST,
	UPSERT_ADDRESS_ERROR,
	CLEAR_ADDRESS_CACHE,
	CLEAR_ADDRESS_ERROR
} from 'actions/CheckoutActions/addressActions';
import { UPSERT_MY_ADDRESS_REQUEST, UPSERT_MY_ADDRESS_ERROR } from 'actions/MyAccountActions/addressActions';

import { CHECKOUT_STATE_CHANGE } from 'actions/CheckoutActions/checkoutVisualStateActions';
import { LOADING, INIT, ERROR } from 'utils/asyncStatusHelper';
import { INITIAL_ADDRESS } from 'constants/CheckoutConstants';

const INITIAL_STATE = {
	[INITIAL_ADDRESS.id]: INITIAL_ADDRESS
};

function updatedState(addressId, state, finalState = {}, options = { destroy: false }) {
	const address = state[addressId];
	if (options.destroy) {
		return Object.assign({}, state, { [addressId]: finalState });
	}

	const updatedAddress = Object.assign({}, address, finalState);
	return Object.assign({}, state, { [addressId]: updatedAddress });
}

export default function addressCache(state = INITIAL_STATE, action = {}) {
	switch (action.type) {
		case CACHE_ADDRESS:
			return updatedState(action.address.id, state, action.address);

		// When the user edits/creates a new address successfully, the checkout
		// state advancement triggers a component unmount on the address form,
		// which in turn caches the address. We need to purge the address cache
		// everytime user goes back to the address section.
		case CHECKOUT_STATE_CHANGE:
			return INITIAL_STATE;

		case CLEAR_ADDRESS_CACHE:
			return updatedState(action.addressId, state, { asyncStatus: INIT }, { destroy: true });
		case CLEAR_ADDRESS_ERROR:
			return updatedState(action.address.id, state, {
				addressResponse: {},
				addressValidation: {},
				error: {}
			});

		case UPSERT_ADDRESS_REQUEST:
		case UPSERT_MY_ADDRESS_REQUEST:
			return updatedState(action.address.id, state, {
				...action.address,
				asyncStatus: LOADING,
				addressResponse: null
			});

		case UPSERT_ADDRESS_ERROR:
		case UPSERT_MY_ADDRESS_ERROR:
			return updatedState(action.addressId, state, {
				asyncStatus: ERROR,
				error: action.error,
				addressValidation: action.addressResponse, // TODO: Ask mAPI team to make the key consistent for address related response
				addressResponse: action.addressResponse
			});
		default:
			return state;
	}
}
